import { Menu } from 'lucide-react';
import { useCallback } from 'react';

import { AlarmBar } from '@/components/navigation/top/components/alarm-bar';
import { EaiBadge } from '@/components/navigation/top/components/eai-badge';
import { ForcedIOBadge } from '@/components/navigation/top/components/forced-io-badge';
import { useNavStore } from '@/stores/nav';

export const MobileTopNav = ({
  facilityName,
  showEaiBadge,
}: {
  facilityName: string;
  showEaiBadge: boolean;
}) => {
  const { expanded, setExpanded } = useNavStore();

  const handleMenuIconClick = useCallback(() => {
    setExpanded(!expanded);
  }, [expanded, setExpanded]);

  return (
    <div
      id={'mobile-top-nav'}
      className={
        'mb-4 mx-5 flex flex-row items-center gap-4 border-b border-border min-h-[5.125rem] max-h-[5.125rem]'
      }
    >
      <div id={'mobile-facility'} className={'flex flex-row gap-2 min-w-0 flex-1 items-center'}>
        <Menu
          size={'2rem'}
          className={'cursor-pointer text-foreground shrink-0'}
          onClick={handleMenuIconClick}
        />
        <div className={'text-foreground font-bold text-2xl truncate min-w-0'}>{facilityName}</div>
      </div>
      <div
        id={'mobile-alarms'}
        className={'flex flex-row align-middle gap-2 shrink-0 items-center'}
      >
        <ForcedIOBadge label={'I/O: '} className={'font-semibold text-sm'} />
        <AlarmBar />
        {showEaiBadge && <EaiBadge />}
      </div>
    </div>
  );
};
